import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    id: "two-wheelers",
    title: "Two Wheelers",
    image: "/project/images/services-img.png",
  },
  {
    id: "four-wheelers",
    title: "Four Wheelers",
    image: "/project/images/services-img2.png",
  },
  {
    id: "trucks",
    title: "Trucks",
    image: "/project/images/services-img3.png",
  },
];

function ServicesSection() {
  return (
    <section className="servies-sec wow fadeInUp" data-wow-duration="2s">
      <div className="container">
        <div className="row">
          {/* Text Column */}
          <div className="col-lg-4 wow fadeInLeft" data-wow-delay="0.3s">
            <div className="about-text">
              <h6 className="wow fadeInDown" data-wow-delay="0.2s">Services</h6>
              <h2 className="wow fadeInUp" data-wow-delay="0.3s">OUR BEST SERVICES</h2>
              <p className="wow fadeInUp" data-wow-delay="0.5s">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam expedita, fugiat est iste eveniet a magnam impedit ipsam laudantium quidem!
              </p>
              <div className="btn-red wow fadeInUp" data-wow-delay="0.8s">
                <Link to="/services">Read more</Link>
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="col-lg-8">
            <div className="row">
              {services.map((service, index) => (
                <div className="col-lg-4" key={index}>
                  <div className="product-silder-box">
                    <div className="product-silder-img">
                      <img src={service.image} alt={service.title} />
                      <div className="product-silder-text">
                        <h5>
                          <Link to={`/services/${service.id}`}>
                            {service.title} <i className="fa-solid fa-arrow-right"></i>
                          </Link>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
